<template>
	<el-container class="friend-page">
		<el-aside width="260px" class="aside">
			<div class="header" style="position: relative;">
				<img src="@/assets/image/icon_Search@2x.png" alt="" class="search-icon" style="width: 20px;height: 20px;position: absolute;z-index: 1;left: 25px;top: 15px;">

				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText" style="">
					<!-- <i class="el-icon-search el-input__icon" slot="prefix"> </i> -->
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" title="添加好友"
					@click="onShowAddFriend()"></el-button>
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"></add-friend>
			</div>
			<el-scrollbar class="friend-items">
				<div v-for="(friends, i) in friendValues" :key="i" >
	
					<div class="letter" style="font-size: 14px;" >{{ friendKeys[i] }}</div>
					<div style="width: calc(100% - 15px);height: 1px;background-color: #E8EBF0;margin-left: 15px;"></div>
					<div v-for="(friend) in friends" :key="friend.id">
						<friend-item :friend="friend" :active="friend.id === activeFriend.id"
							@chat="onSendMessage(friend)" @delete="onDelFriend(friend)"
							@click.native="onActiveItem(friend)">
						</friend-item>
					</div>
					<div v-if="i < friendValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</el-aside>
		<el-container class="container" style="position: relative;">
			<!-- Loading 动画 -->
			<div v-if="loading" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);text-align:center;">
				<i class="el-icon-loading" style="font-size: 40px; color: #409EFF;"></i>
				<div style="margin-top: 12px; color: #999;">加载中...</div>
			</div>
			<!-- 详细信息内容 -->
			<div v-else v-show="userInfo.id" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
				<div class="friend-info friend-info-center" style="padding: 0!important;">
					<head-image :size="100" :name="userInfo.nickName" :url="userInfo.headImage" radius="10%"
						@click.native="showFullImage()"></head-image>
					<div>
						<div class="real-info" style="margin-top: 16px;">
							<p
								style="width: 300px;margin: 0 auto;text-align: left;font-size: 18px;line-height: 28px;font-weight: 600;margin-bottom: 8px;">
								{{ userInfo.nickName }}</p>
							<p
								style="width: 300px;margin: 0 auto;font-weight: 600;text-align: left;display: flex; align-items: center;font-size: 14px;">
								<img src="@/assets/image/icon_company 1@2x.png" style="width: 18px;height: 18px;margin-right: 4px;"
									alt="">{{ userInfo.orgName }}</p>
						</div>
						<div class="info-item">
							<!-- {{ userInfo }} -->
							<div class="description" :column="1">
							<div style="text-align: left;font-size: 14px;margin-bottom: 12px;">
								<span style="display: inline-block;width: 80px;color: #9E9E9E;">用户名</span>
								<span style="font-weight: 600;">{{ userInfo.userName }}</span>
							</div>
							<div style="text-align: left;font-size: 14px;margin-bottom: 12px;">
								<span style="display: inline-block;width: 80px;color: #9E9E9E;">性别</span>
								<span style="font-weight: 600;">{{ userInfo.sex == 0 ? "男" : "女" }}</span>
							</div>
							<div style="text-align: left;font-size: 14px;margin-bottom: 20px;">
								<span style="display: inline-block;width: 80px;color: #9E9E9E;">签名</span>
								<span style="font-weight: 600;">{{ userInfo.signature }}</span>
							</div>
							
							
						</div>
						</div>
						<div class="btn-group">
							<!-- <el-button v-show="isFriend"
								@click="onSendMessage(userInfo)">发消息</el-button>
							<el-button v-show="!isFriend" icon="el-icon-plus" type="primary"
								@click="onAddFriend(userInfo)">加为好友</el-button>
							<el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(userInfo)">删除好友</el-button> -->
							<div class="send-msg-btn" @click="onSendMessage(userInfo)">
								<img src="@/assets/image/icon_messages2@2x.png" alt=""
									style="width: 24px;height: 24px;margin-bottom: 12px;">
								<span>发消息</span>
							</div>
							<div class="delete-msg-btn" v-show="isFriend" @click="onDelFriend(userInfo)">
								<img src="@/assets/image/icon_delete@2x.png" alt="" style="width: 24px;height: 24px;margin-bottom: 12px;">
								<span>删除好友</span>
							</div>
							<!-- <div class="send-msg-btn" v-show="!isFriend" @click="onAddFriend(userInfo)">
								<img src="@/assets/image/icon_delete@2x.png" alt="" style="width: 24px;height: 24px;">
								<span>添加好友</span>
							</div> -->
						</div>
						<!-- 添加好友弹窗 -->
						<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
							<span>这是一段信息</span>
						</el-dialog>
					</div>
				</div>
			</div>
		</el-container>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import HeadImage from "../components/common/HeadImage.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "friend",
	components: {
		FriendItem,
		AddFriend,
		HeadImage

	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			userInfo: {},
			activeFriend: {},
			dialogVisible:false,
			loading: false
		}
	},
	methods: {
		// 自动选择第一个好友
		autoSelectFirstFriend() {
			const friends = this.friendStore.friends.filter(friend => !friend.deleted);
			if (friends.length > 0 && !this.activeFriend.id) {
				const firstFriend = friends[0];
				this.onActiveItem(firstFriend);
			}
		},
		// 添加好友模态框关闭之前
		handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onActiveItem(friend) {
			this.activeFriend = friend;
			this.loadUserInfo(friend.id);
		},
		onDelFriend(friend) {
			this.$confirm(`即将删除选中的联系人，并同时删除与该联系人的聊天记录`, '删除联系人', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success("删除好友成功");
					this.$store.commit("removeFriend", friend.id);
					this.$store.commit("removePrivateChat", friend.id);
				})
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then(() => {
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImage,
					online: user.online
				}
				this.$store.commit("addFriend", friend);
			})
		},
		onSendMessage(user) {
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: user.nickName,
				headImage: user.headImageThumb,
			};
			this.$store.commit("openChat", chat);
			this.$store.commit("activeChat", 0);
			this.$router.push("/home/chat");
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$store.commit('showFullImageBox', this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				this.$store.commit("updateChatFromFriend", friend);
				this.$store.commit("updateFriend", friend);
			}
		},
		loadUserInfo(id) {
			// 获取好友用户信息
			this.loading = true;
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			}).finally(() => {
				this.loading = false;
			});
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	computed: {
		friendStore() {
			return this.$store.state.friendStore;
		},
		isFriend() {
			return this.$store.getters.isFriend(this.userInfo.id);
		},
		friendMap() {
			// 按首字母分组
			let map = new Map();
			this.friendStore.friends.forEach((f) => {
				if (f.deleted || (this.searchText && !f.nickName.includes(this.searchText))) {
					return;
				}
				let letter = this.firstLetter(f.nickName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			// 排序
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				// #组在最后面
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		friendKeys() {
			return Array.from(this.friendMap.keys());
		},
		friendValues() {
			return Array.from(this.friendMap.values());
		}
	},
	mounted() {
		// 组件挂载时检查是否需要自动选择第一个好友
		this.$nextTick(() => {
			if (this.friendStore.friends.length > 0 && !this.activeFriend.id) {
				this.autoSelectFirstFriend();
			}
		});
	},
	watch: {
		// 监听好友列表变化
		'friendStore.friends': {
			handler(newFriends) {
				// 当好友列表有数据且没有活跃好友时，自动选择第一个
				if (newFriends && newFriends.length > 0 && !this.activeFriend.id) {
					this.autoSelectFirstFriend();
				}
			},
			deep: true
		}
	}
}
</script>

<style lang="scss" scoped>
.friend-page::v-deep {
	.aside {
		display: flex;
		flex-direction: column;
		background: var(--im-background);

		.header {
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0 16px;
			.el-input{
				border: none;
				outline: none;
				.el-input__inner{
					border: none;
					outline: none;
					background-color: #EAEAEA;
					padding-left: 36px;
					&::placeholder {
						color: #9E9E9E !important;
						opacity: 1;
					}
				}
			}
			.add-btn {
				width: 32px!important;
				height: 32px;
				color: #9e9e9e;
				padding: 5px 8px !important;
				margin: 5px;
				font-size: 16px;
				border-radius: 4px;
				border: none;
				background-color: #EAEAEA;
			}
		}

		.friend-items {
			flex: 1;

			.letter {
				text-align: left;
				font-size: var(--im-larger-size-larger);
				padding: 5px 15px;
				color: var(--im-text-color-light);
			}
		}
	}

	.container {
		display: flex;
		flex-direction: column;

		.header {
			height: 50px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 12px;
			font-size: var(--im-font-size-larger);
			border-bottom: var(--im-border);
			box-sizing: border-box;
		}

		.friend-info {
			// display: flex;
			padding: 16px;
			background-color: white;

			// text-align: center;
			.head-image {
				width: 300PX;
				margin: 0 auto;

				.avatar-text {
					width: 80px !important;
					height: 80px !important;
					font-size: 28px !important;
				}

				.avatar-image {
					width: 80px !important;
					height: 80px !important;
				}
			}


			.info-item {
				width: 300px;
				margin: 0 auto;
				background-color: #ffffff;
				border-top: 1px #ddd solid;
				border-bottom: 1px #ddd solid;
				margin-top: 20px;

			}

			.description {
				padding: 20px 20px 0 0px;
			}
		}

		.btn-group {
			text-align: left !important;
			padding: 20px;
			width: 300px;
			margin: 0 auto;

			.send-msg-btn {
				display: inline-block;
				text-align: center;
				margin-right: 20px;
				padding: 8px 23px;
				border-radius: 8px;
				&:hover {
					background-color: #f7f7f7;
				}
				img {
					display: block;
					margin: 0 auto;
				}

				span {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #027AFF;
					line-height: 22px;
					text-align: center;
					font-style: normal;
					text-transform: none;
				}
			}

			.delete-msg-btn {
				display: inline-block;
				text-align: center;
				margin-right: 20px;
				padding: 8px 16px;
				border-radius: 8px;
				&:hover {
					background-color: #f7f7f7
				}
				img {
					display: block;
					margin: 0 auto;
				}

				span {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: rgba(250, 81, 81, 1);
					line-height: 22px;
					text-align: center;
					font-style: normal;
					text-transform: none;
				}
			}
		}
	}
}
.friend-info-center {
  display: flex;
  flex-direction: column;
  align-items: center;
//   justify-content: center;
  padding: 0;
}
.friend-page .container .friend-info {
    padding: 0!important;
}
.friend-nickname {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}
.friend-org {
  font-size: 14px;
  color: #666;
  font-weight: 400;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-item-center {
  width: 320px;
  margin: 0 auto 16px auto;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  box-shadow: none;
  padding: 0 0 0 0;
}
.friend-username {
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.friend-desc {
  font-size: 14px;
  color: #666;
  font-weight: 400;
}
.btn-group-center {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 24px;
}
.btn-blue {
  color: #027AFF;
  font-size: 14px;
  font-weight: 400;
  margin-top: 4px;
  display: block;
}
.btn-red {
  color: #FA5151;
  font-size: 14px;
  font-weight: 400;
  margin-top: 4px;
  display: block;
}
</style>

<style lang="scss">
/* 自定义 el-message-box 确认按钮为红色边框红色字，背景透明 */
.el-message-box__btns .el-button--primary {
  color: #fa5151 !important;
  border: 1px solid #fa5151 !important;
  background: #fff !important;
}
.el-message-box__btns .el-button--primary:hover,
.el-message-box__btns .el-button--primary:focus {
  background: #fa5151 !important;
  color: #fff !important;
  border: 1px solid #fa5151 !important;
}

/* 让警告图标（叹号）变大 */
.el-message-box__status.el-icon-warning {
  display: none !important;
}
.el-message-box {
  width: 372px !important;
  min-width: 372px !important;
  max-width: 372px !important;
}
.el-message-box__message {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
</style>